import { render } from "./dataTableINeedToSign.vue?vue&type=template&id=d2df81b4&scoped=true&ts=true"
import script from "./dataTableINeedToSign.vue?vue&type=script&lang=ts"
export * from "./dataTableINeedToSign.vue?vue&type=script&lang=ts"

import "./dataTableINeedToSign.vue?vue&type=style&index=0&id=d2df81b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2df81b4"]])

export default __exports__